import { DateTime } from "luxon";
import type { PaginatedDualApproval } from "byzantine/src/dbbl/businessLogic/entities/dualApprovals";

const shouldShowDueSoon = (dualApproval: PaginatedDualApproval): boolean => {
  if (!dualApproval.scheduledACHId || !dualApproval.schedule?.scheduledDate)
    return false;
  const today = DateTime.utc().startOf("day");
  const scheduled = DateTime.fromISO(dualApproval.schedule.scheduledDate)
    .toUTC()
    .startOf("day");
  const oneDayBefore = scheduled.minus({ days: 1 });
  return today.equals(oneDayBefore) || today.equals(scheduled);
};

export default shouldShowDueSoon;
